import * as tslib_1 from "tslib";
import { ElementRef, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { MessageService } from '@core/errors/messages-service';
import { fileToBase64 } from '@core/utils/file-converter';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { TranslateService } from '@ngx-translate/core';
import compress from 'browser-image-compression';
import { merge } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { FcCompanyInputComponent } from '../../../../../../core/components/fc-input/search-one/fc-company-input/fc-company-input.component';
import { DialogSchedulingSuggestionsComponent } from '../../../dialog-scheduling-suggestions/dialog-scheduling-suggestions.component';
var TabGeneralComponent = /** @class */ (function () {
    function TabGeneralComponent(matDialog, translate, messageService, progressBar, authenticationService) {
        this.matDialog = matDialog;
        this.translate = translate;
        this.messageService = messageService;
        this.progressBar = progressBar;
        this.authenticationService = authenticationService;
        this.problems = [];
        this.validation = [];
        this.isLoading = false;
        this.allowedExtensions = [
            'csv',
            'txt',
            'jpg',
            'jpeg',
            'png',
            'jfif',
            'heic',
            'webp',
            'mp4',
            'pdf',
            'doc',
            'xls',
            'ppt',
            'docx',
            'xlsx',
            'pptx',
            'kml',
            'dwg',
            'zip',
            'xml'
        ];
        this.isProblemRequired = this.authenticationService.hasAccountPreference({
            property: 'openMaintenance',
            subProperty: 'featureProblemRequired',
            expectedValue: true,
            defaultIfUndefined: false
        });
        this.maintenanceNumberGeneratorType = this.authenticationService.getAccountPreference({
            property: 'openMaintenance',
            subProperty: 'maintenanceNumberGenerator',
            defaultIfNull: 'sequential'
        });
    }
    TabGeneralComponent.prototype.ngOnInit = function () {
        var _this = this;
        var locationControl = this.maintenanceForm.get('location');
        var addressControl = this.maintenanceForm.get('address');
        merge(locationControl.valueChanges, addressControl.valueChanges)
            .pipe(debounceTime(500))
            .subscribe(function () {
            _this.companyInput.resetSearch();
        });
    };
    TabGeneralComponent.prototype.openSchedulingSuggestionsDialog = function () {
        this.matDialog.open(DialogSchedulingSuggestionsComponent, {
            panelClass: ['scheduling-suggestions'],
            width: '553px',
            disableClose: true,
            data: this.maintenanceForm.get('scheduleSuggestions')
        });
    };
    TabGeneralComponent.prototype.removeAttachment = function (event, index) {
        event.stopPropagation();
        this.maintenanceForm.get('attachments').value.splice(index, 1);
    };
    TabGeneralComponent.prototype.handleDropFile = function (event) {
        event.stopPropagation();
        event.preventDefault();
        this.onFileChange(Array.from(event.dataTransfer.files || []));
    };
    TabGeneralComponent.prototype.handleFileSelect = function (event) {
        var input = event.target;
        this.onFileChange(Array.from(input.files || []));
        var files = new DataTransfer().files;
        input.files = files;
    };
    TabGeneralComponent.prototype.onFileChange = function (files) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var MAX_SIZE, ATTACHMENT_LIMIT, _loop_1, this_1, files_1, files_1_1, file, e_1_1;
            var e_1, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        this.progressBar.show();
                        MAX_SIZE = 2 * 1024 * 1024;
                        ATTACHMENT_LIMIT = 10;
                        _loop_1 = function (file) {
                            var hash, extension, isImage, alreadyAdded, extensionNotAllowed, compressedFile, _a, thumb, _b, isTooBig, attachmentsLimit, _c, _d, _e, _f;
                            return tslib_1.__generator(this, function (_g) {
                                switch (_g.label) {
                                    case 0:
                                        hash = file.size + "_" + file.name;
                                        extension = file.name.split('.').pop();
                                        isImage = file.type.startsWith('image/');
                                        alreadyAdded = this_1.maintenanceForm.get('attachments').value.some(function (attachment) { return attachment.hash === hash; });
                                        if (alreadyAdded) {
                                            this_1.messageService.warn(this_1.translate.instant('MAINTENANCES.CREATE_DIALOG.FILE_DUPLICATED'), {
                                                fileName: file.name
                                            });
                                            return [2 /*return*/, "continue"];
                                        }
                                        extensionNotAllowed = !this_1.allowedExtensions.includes(extension.toLowerCase());
                                        if (extensionNotAllowed) {
                                            this_1.messageService.warn(this_1.translate.instant('MAINTENANCES.CREATE_DIALOG.EXTENSION_INVALID'), {
                                                fileName: file.name
                                            });
                                            return [2 /*return*/, "continue"];
                                        }
                                        if (!isImage) return [3 /*break*/, 2];
                                        return [4 /*yield*/, compress(file, { maxSizeMB: MAX_SIZE, maxWidthOrHeight: 1920 })];
                                    case 1:
                                        _a = _g.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        _a = file;
                                        _g.label = 3;
                                    case 3:
                                        compressedFile = _a;
                                        if (!isImage) return [3 /*break*/, 5];
                                        return [4 /*yield*/, compress(compressedFile, { maxWidthOrHeight: 256 })];
                                    case 4:
                                        _b = _g.sent();
                                        return [3 /*break*/, 6];
                                    case 5:
                                        _b = null;
                                        _g.label = 6;
                                    case 6:
                                        thumb = _b;
                                        isTooBig = compressedFile.size > MAX_SIZE;
                                        if (isTooBig) {
                                            this_1.messageService.warn(this_1.translate.instant('MAINTENANCES.CREATE_DIALOG.FILE_TOO_BIG'));
                                            return [2 /*return*/, "continue"];
                                        }
                                        attachmentsLimit = this_1.maintenanceForm.get('attachments').value.length >= ATTACHMENT_LIMIT;
                                        if (attachmentsLimit) {
                                            this_1.messageService.warn(this_1.translate.instant('MAINTENANCES.CREATE_DIALOG.LIMIT_REACHED'));
                                            return [2 /*return*/, "continue"];
                                        }
                                        _d = (_c = this_1.maintenanceForm.get('attachments').value).push;
                                        _e = {
                                            hash: hash
                                        };
                                        if (!isImage) return [3 /*break*/, 8];
                                        return [4 /*yield*/, fileToBase64(thumb)];
                                    case 7:
                                        _f = _g.sent();
                                        return [3 /*break*/, 9];
                                    case 8:
                                        _f = null;
                                        _g.label = 9;
                                    case 9:
                                        _d.apply(_c, [(_e.thumb = _f,
                                                _e.file = compressedFile,
                                                _e.filename = file.name,
                                                _e.size = compressedFile.size,
                                                _e.type = file.type,
                                                _e)]);
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, 7, 8]);
                        files_1 = tslib_1.__values(files), files_1_1 = files_1.next();
                        _b.label = 2;
                    case 2:
                        if (!!files_1_1.done) return [3 /*break*/, 5];
                        file = files_1_1.value;
                        return [5 /*yield**/, _loop_1(file)];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        files_1_1 = files_1.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1_1 = _b.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (files_1_1 && !files_1_1.done && (_a = files_1.return)) _a.call(files_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 8:
                        this.attachmentsDiv.nativeElement.classList.remove('drag-over');
                        this.isLoading = false;
                        this.progressBar.hide();
                        return [2 /*return*/];
                }
            });
        });
    };
    return TabGeneralComponent;
}());
export { TabGeneralComponent };
